<template>
  <div>
    <CRow>
      <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="pb-0">
        <div class="d-flex">
          <h1 class="dashboard_page_title flex-grow-1">Turnover</h1>
          <div v-if="showDownloadButtons" class="insights_download_buttons text-right">
            <div class="mt-1 mt-xl-0 d-inline-block align-top">
              <CButton class="link m-0" color="primary" @click="makeScreenshot()">
                <i class="fas fa-image mr-1"/><span>{{ $t('insights.Save_as_image') }}</span>
              </CButton>                
            </div>
          </div>
        </div>
      </CCol>
    </CRow>

    <SmartFilters ref="smartFilters" :parent="'pa_turnover_insights'"/>    

    <CRow ref="screenshotContent" class="insights" v-bind:class="{'printing' : printingInsights}">
      <CCol cols="4" xl="4" lg="4" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount</span>
              </CCol>       
            </CRow>       
          </CCardHeader>          
          <CCardBody class="pt-0">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <Count v-else mode="with_description" :count="turnoverInsightsData.headcount" countTitle="Headcount" :countIcon="null"/>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol cols="4" xl="4" lg="4" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per Gender</span>
              </CCol>       
            </CRow>
          </CCardHeader>          
          <CCardBody class="pt-0">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <GenderPolarChart v-else :chartData="turnoverInsightsData.headcount_gender" chartHeight="250" :companyPrimaryColor="companyPrimaryColor"/>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol cols="4" xl="4" lg="4" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per work mode</span>
              </CCol>       
            </CRow>       
          </CCardHeader>          
          <CCardBody class="pt-0">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <OfficeBasedPolarChart v-else :chartData="turnoverInsightsData.headcount_office_based" chartHeight="250" :companyPrimaryColor="companyPrimaryColor"/>
          </CCardBody>
        </CCard>
      </CCol>      

      <CCol cols="4" xl="4" lg="6" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per age category</span>
              </CCol>       
            </CRow>       
          </CCardHeader>          
          <CCardBody class="pt-0">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <HeadcountAgeChart v-else :chartData="turnoverInsightsData.headcount_age" :companyPrimaryColor="companyPrimaryColor"/>
          </CCardBody>
        </CCard>
      </CCol>
      
      <CCol cols="4" xl="4" lg="6" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per work location</span>
              </CCol>       
            </CRow>       
          </CCardHeader>          
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <HeadcountWorkLocationChart v-else :chartSeries="turnoverInsightsData.headcount_work_location" chartHeight="400px" :companyPrimaryColor="companyPrimaryColor"/>
          </CCardBody>
        </CCard>
      </CCol>
            
      <CCol cols="4" xl="4" lg="6" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per function</span>
              </CCol>       
            </CRow>       
          </CCardHeader>          
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <HeadcountFunctionTreemapChart v-else :chartSeries="turnoverInsightsData.headcount_function" chartHeight="400" :companyPrimaryColor="companyPrimaryColor"/>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol cols="4" xl="4" lg="6" md="12" sm="12">
        <CCard class="mb-0 h-100">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per Department</span>
              </CCol>       
            </CRow>
          </CCardHeader>
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <div v-else class="h-100 d-flex flex-column align-items-center justify-content-center">
              <HeadcountDepartmentsChart :chartSeries="turnoverInsightsData.headcount_departments" chartHeight="400" :companyPrimaryColor="companyPrimaryColor"/>
            </div>
          </CCardBody>
        </CCard>
      </CCol>      
      
      <CCol cols="4" xl="4" lg="6" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per DISC type</span>
              </CCol>       
            </CRow>       
          </CCardHeader>          
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <HeadcountDiscChart v-else :chartSeries="turnoverInsightsData.headcount_disc" chartHeight="400" :companyPrimaryColor="companyPrimaryColor"/>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol cols="4" xl="4" lg="6" md="12" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per Myers Briggs type</span>
              </CCol>       
            </CRow>       
          </CCardHeader>          
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <HeadcountMyersBriggsChart v-else :chartData="turnoverInsightsData.headcount_mbti" chartHeight="400" :companyPrimaryColor="companyPrimaryColor"/>
          </CCardBody>
        </CCard>
      </CCol>      
      
      <CCol cols="12" xl="12" lg="12" md="12" sm="12">
        <CCard class="mb-0 h-100">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Headcount per Contract Type</span>
              </CCol>       
            </CRow>
          </CCardHeader>
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <div v-else class="h-100 d-flex flex-column align-items-center justify-content-center">
              <HeadcountContractChart :chartData="turnoverInsightsData.headcount_contract_type" :companyPrimaryColor="companyPrimaryColor"/>
            </div>
          </CCardBody>
        </CCard>
      </CCol>    
      
      <CCol cols="8" xl="8" lg="8" md="8" sm="12">
        <CCard class="mb-0 h-100">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Hires & leavers</span>
              </CCol>       
            </CRow>
          </CCardHeader>
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <div v-else class="h-100 d-flex flex-column align-items-center justify-content-center">
              <HiresLeaversChart :chartData="turnoverInsightsData.hires_vs_leavers" :companyPrimaryColor="companyPrimaryColor"/>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol cols="4" xl="4" lg="4" md="4" sm="12">
        <CCard class="h-100 mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="text-left pt-0 pb-0">
                <span>Average turnover rate</span>
              </CCol>       
            </CRow>       
          </CCardHeader>
          <CCardBody class="pt-0" :class="{'pb-0' : !loadingData}">
            <div v-if="loadingData" class="h-100 d-flex align-items-center">
              <loadingSpinner mode="auto" :content="null"/>
            </div>
            <Count v-else mode="with_description" :count="turnoverInsightsData.avg_turnover_rate_12_months.turnover_rate" countTitle="Average turnover rate 12 months" :countIcon="null"/>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>   
  </div>
</template>

<script>
import axios from 'axios'
import loadingSpinner from '@/components/common/loadingSpinner.vue';
import Multiselect from 'vue-multiselect';
import noPermission from '@/components/common/noPermission.vue';

import SmartFilters from '@/components/insights/common/SmartFilters.vue';
import Count from '@/components/insights/common/Count.vue';
import BarChart from '@/components/insights/common/BarChart.vue';

import HiresLeaversChart from '@/components/insights/reports/HiresLeaversChart.vue';
import HeadcountContractChart from '@/components/insights/reports/HeadcountContractChart.vue';
import HeadcountDepartmentsChart from '@/components/insights/reports/HeadcountDepartmentsChart.vue';
import HeadcountWorkLocationChart from '@/components/insights/reports/HeadcountWorkLocationChart.vue';
import HeadcountFunctionTreemapChart from '@/components/insights/reports/HeadcountFunctionTreemapChart.vue';
import HeadcountDiscChart from '@/components/insights/reports/HeadcountDiscChart.vue';
import HeadcountMyersBriggsChart from '@/components/insights/reports/HeadcountMyersBriggsChart.vue';
import GenderPolarChart from '@/components/insights/reports/GenderPolarChart.vue';
import HeadcountAgeChart from '@/components/insights/reports/HeadcountAgeChart.vue';
import OfficeBasedPolarChart from '@/components/insights/reports/OfficeBasedPolarChart.vue';

export default {
  name: 'Turnover',
  components: {
    loadingSpinner,
    Multiselect,
    noPermission,
    SmartFilters,
    Count,
    BarChart,
    HiresLeaversChart,
    HeadcountContractChart,
    HeadcountDepartmentsChart,
    HeadcountWorkLocationChart,
    HeadcountFunctionTreemapChart,
    HeadcountDiscChart,
    HeadcountMyersBriggsChart,
    GenderPolarChart,
    HeadcountAgeChart,
    OfficeBasedPolarChart
  },
  data() {
    return {
      platformPermissions: [],
      platformPermissionsLoaded: false,      
      loadingData: false,      
      turnoverInsightsData: {
        hires_vs_leavers: [],
        headcount: 0,
        headcount_departments: [],
        headcount_contract_type: {},
        headcount_gender: [],
        headcount_age: {} ,
        headcount_work_location: [],
        headcount_function: [],
        headcount_office_based: [],
        headcount_disc: [],
        headcount_mbti: [],
        avg_turnover_rate_12_months: {
          turnover_rate: 0
        }
      },
      showDownloadButtons: false,
      printingInsights: false,
      companyPrimaryColor: '#00875A',
      smartFilters: []
    }
  },
  methods: {
    getTurnoverData() {
      let params = {};
      params.filters = this.smartFilters;
      // Start the loader
      this.loadingData = true;   
      // Get the topics insights data
      axios.post(process.env.VUE_APP_API_URL + '/v1/insights/reports/turnover', params)
      .then(res => {
        // Set the turnoverInsightsData
        this.turnoverInsightsData = res.data.data;
        // Set the companyPrimaryColor value
        this.companyPrimaryColor = getComputedStyle(document.documentElement).getPropertyValue('--DashboardPrimary');        
        // Set timeout for 2 seconds
        setTimeout(function(){
          // Close the loader
          this.loadingData = false;
          // Update the showDownloadButtons value
          this.showDownloadButtons = true;
        }.bind(this), 2000)                         
      })
      .catch(err => {
        console.error(err); 
      });                  
    },
    makeScreenshot() {
      window.scroll(0,0);
      // Update printingInsights value
      this.printingInsights = true;
      // Get the HTML to print
      const content = this.$refs.screenshotContent;
      // Set the html2canvas options
      const options = { type: "dataURL", useCORS: true };

      setTimeout(function() {
        // Print the screenshot
        this.printScreenshot(content, options);
        // Reset the printingInsights value
        this.printingInsights = false;
      }.bind(this), 500);
    },
    async printScreenshot(content, options) {
      // Create canvas for printing
      const printCanvas = await html2canvas(content, options);
      // Creata a link element to download the generated canvas
      const link = document.createElement("a");

      let exportSubject = 'Turnover';
      exportSubject = exportSubject.replace(/\s/g, '');
      exportSubject = exportSubject.toLowerCase();      

      link.setAttribute("download", "insights_" + exportSubject + "_" + new Date().toLocaleString() + ".png");
      link.setAttribute("href", printCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
      link.click();
    },
    getPlatformPermissions() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/permissions')
      .then(res => {      
        this.platformPermissions = res.data.data;
        // Update the platformPermissionsLoaded value
        this.platformPermissionsLoaded = true;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    checkPermission(permissionTag) {
      if(this.platformPermissions.includes(permissionTag)) {
        return true;
      } else{
        return false;
      }
    }    
  },
  mounted: function() {    
    this.getPlatformPermissions();
    this.getTurnoverData();

    this.$bus.$on('pa_turnover_insights_smart_filters_updated', (filters) => {
      this.smartFilters = filters;
      this.getTurnoverData();      
    });    
  },
  beforeDestroy() {
    this.$bus.$off('pa_turnover_insights_smart_filters_updated');
  }
}
</script>